import { render, staticRenderFns } from "./ContentHeader.global.vue?vue&type=template&id=1a90048a&scoped=true&lang=pug&"
import script from "./ContentHeader.global.vue?vue&type=script&lang=ts&"
export * from "./ContentHeader.global.vue?vue&type=script&lang=ts&"
import style0 from "./ContentHeader.global.vue?vue&type=style&index=0&id=1a90048a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a90048a",
  null
  
)

export default component.exports